export const homePage = {
    numberSte: 'Количество: <span class="color-green">{count}</span> NFT',
    title: 'Коллекция NFT от AIS',
    titleContent: 'Условия покупки INO:',
    lineContent1: 'Подтвержденная личность',
    lineContent2: 'Каждый аккаунт может купить не более одной мужской футболки и одной женской футболки',
    buttonBuy: 'Купить',
    soldOut: 'Продано',
    numberProducts: 'Количество: <span class="color-red">{count}</span> NFT',
    noLoginTitle: 'Вы не авторизованы',
    contentNoLogin: 'Вам необходимо авторизоваться, чтобы купить NFT.',
    buttonNoLogin: 'Авторизоваться',
    buttonVerify: 'Подтвердить личность',
    changePass: 'Изменить пароль',
    logOut: 'Выйти',
    ok: 'Подтвердить',
    noVerifyTitle: 'Вы еще не подтвердили личность',
    chooseWallet: 'Выберите кошелек для оплаты',
    notEnoughMoney: 'Недостаточно средств на вашем счету.',
    confirmBuy: 'Подтвердить покупку NFT',
    price: 'Стоимость покупки',
    confirmBuyButton: 'Подтвердить покупку',
    loginBuy: 'Авторизуйтесь, чтобы купить',
    timeup: 'Распродажа окончена',
    remain: 'Осталось: {remain}',
    confirmSellButton: 'Продать',
    titleConnectWallet: 'Пожалуйста, подключитесь к кошельку',
    youNeedConnectMetamask: 'Для покупки NFT необходимо подключить кошелек.',
    connectWallet: 'Подключить кошелек',
    noVerifyContent: 'Для покупки NFT необходимо подтвердить свою личность.',
    noVerifyButton: 'Подтвердить личность',
    rejectVerifyTitle: 'Ваш аккаунт был отклонен\n при подтверждении личности',
    rejectVerifyContent: 'Для покупки NFT необходимо повторно подтвердить свою личность.',
    rejectVerifyButton: 'Подтвердить повторно',
    pendingVerifyTitle: 'Ваш аккаунт находится в\n ожидании подтверждения',
    penddingVerifyButton: 'Ок',

    approvedTitle: 'Скоро начнется распродажа',
    approvedSubTitle1: 'Начало распродажи:',
    approvedLine1: '21/06/2022 08:00 UTC',
    approvedLine2: ' Этап 2: 70 NFT Футболок для женщин, начало 18/06/2022 в 15:00',
    approvedSubTitle2: 'Условия покупки',
    approvedLine3:
        'Этап 3: 70 NFT Футболок для мужчин и 30 NFT Футболок для женщин, начало 21/06/2022 в 15:00',
    approvedLine4: 'Всего NFT Футболок для мужчин: 100, для женщин: 100',
    approvedLine5: 'Каждый аккаунт может купить не более одной мужской футболки и одной женской футболки',
    approvedLine6: 'Зарегистрированный аккаунт и подтвержденная личность',
    approvedButton: 'Ок',

    connectPayButton: 'Подключить кошелек',
    pedding: 'Ожидание подтверждения',
    peddingTitle: 'Ваш аккаунт ожидает\n подтверждения',
    successVerifyTitle: 'Ваш аккаунт был успешно\n подтвержден',
    successVerifyButton: 'Ок',
    message: {
        titleConnectWallet: 'Подключение кошелька',
        deviceNotSupport: 'Устройство не поддерживается',
        connectFail: 'Не удалось подключиться',
        opened: 'Пожалуйста, откройте окно Metamask для подтверждения входа',
    },
    buttonRegister: 'Зарегистрироваться сейчас',
    buttonTextVerify: 'Подтвердить сейчас',
    newItemTitle: 'Новости',
    walletTitle: 'Кошелек',
    walletBalance: 'Баланс',
    loadWallet: 'Пополнить',
    loadWalletTitle: 'Пополнить',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: 'Отправьте AIS, SB, BNB, USDT на этот кошелек',
    walletAddress: 'Адрес кошелька',
    scanAddress: 'Отсканируйте адрес для получения платежа',
    withdrawWallet: 'Вывести',
    withdrawWalletTitle: 'Вывести STE',
    commonSoon: 'Скоро',
    okie: 'Ок',
    copyAddress: 'Адрес кошелька скопирован',
    productTitle: 'Коллекция NFT от AIS',
    remainTimeBuy: 'Оставшееся время для покупки: ',
    bannerTitle: 'Откройте для себя эксклюзивные и уникальные коллекции NFT',
    line1: '21/06/2022 08:00 UTC',
    line2: ' Этап 2: 70 NFT Футболок для женщин, начало 18/06/2022 в 15:00',
    bannerSubTitle: 'Условия покупки',
    line3: 'Этап 3: 70 NFT Футболок для мужчин и 30 NFT Футболок для женщин, начало 21/06/2022 в 15:00',
    line4: 'Всего NFT Футболок для мужчин: 100, для женщин: 100',
    line5: 'Каждый аккаунт может купить не более одной мужской футболки и одной женской футболки',
    line6: 'Зарегистрированный аккаунт и подтвержденная личность',
    haveOwned: 'Уже куплено',
    modalFire: {
        title: 'Поздравляем!',
        subTitle: 'INO STE фаза <span>{count}</span> завершена',
        content1: 'Поздравляем победителей, которым удалось\n стать владельцами NFT STE',
        content2:
            ' Если вы не смогли приобрести в этот раз, присоединитесь к фазе <span>{count}</span> в 15:00 (VN)',
        stage1: ' 18 июня',
        stage2: ' 21 июня',
    },
    coming_soon: 'СКОРО',
    download: 'ЗАГРУЗИТЬ',


    filter_order: 'Сортировка',
    filter_nft: 'Фильтр по типу NFT',
    filter_mint: 'Фильтр по количеству минтов',
    filter_token: 'Фильтр по типу токена',
    newest: 'Новые',
    price_asc: 'Цена: По возрастанию ↑',
    price_desc: 'Цена: По убыванию ↓',
    all: 'Все',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: 'Пара Mint',
    last1: 'Остался 1 раз',
    last2: 'Осталось 2 раза',
    last3: 'Осталось 3 раза',
    last4: 'Осталось 4 раза',
    last5: 'Осталось 5 раз',
    last6: 'Осталось 6 раз',
    last7: 'Осталось 7 раз',
    new: 'Новый',
    expire: 'Срок действия истек',
    cancel_sell: 'ОТМЕНА ПРОДАЖИ',
    confirm_cancel: 'Отменить продажу NFT',
    price_sell: 'Цена продажи:',
    fee: 'Комиссия за продажу 5%:',
    ste_receive: 'Вы получите {0} STE:',
    couple_des: 'NFT, промаркированные вместе, должны быть проданы в паре (NFT M и NFT W).',
    invite: 'Пригласить друзей',
    invite_title: 'Пригласить друзей',
    rule: 'Правила',
    rule1: 'Поделитесь своим кодом реферала/ссылкой с другом, у которого нет аккаунта',
    rule2: 'Приглашенный пользователь должен успешно пройти процедуру идентификации и присоединиться к тренировкам',
    rule3: 'За каждый успешный реферал вы получите 4 дня бесплатной игры',
    id_invite: 'Ваш код реферала',
    linkref: 'Ссылка для приглашения',
    ref_code: 'Реферальный код',
    copy_success: 'Успешно скопировано!',
    condition_sell: 'Условия продажи NFT',
    condition_sell1: '1. NFT является NEW (не использованным).',
    condition_sell2: '2. NFT, использованный более 7 раз, может быть продан (NFT, получивший менее 7 наград, не может быть продан).',
    condition_sell3: '3. NFT, промаркированный вместе, должен быть продан в паре (NFT M и NFT W).',
    condition_sell4: '4. Использованный NFT, получивший более 7 наград , будет сохранять срок действия до его истечения, когда продан, срок действия автоматически становится ИСТЕК. Если продавец отменяет продажу, срок действия будет равен числу дней, которое было рассчитано.',
    condition_sell5: '5. NFT, находящийся на продаже, не может быть использован для тренировок.',
    condition_sell6: '6. Использованный NFT должен иметь оставшиеся минты.',
    nft_not_mint: 'Не промаркированные NFT',
    sell: 'Продать',
    confirm_sell: 'Подтвердить продажу NFT',
    transfer_confirm: 'Подтверждение передачи NFT',
    fee_transfer: 'Комиссия за перевод:',
    sell_placeholder: 'Введите цену продажи',
    valid_price: 'Пожалуйста, введите действительную цену продажи',
    priceSellRequired: 'Пожалуйста, введите цену продажи',
    confirm_text: 'Подтвердить',
    change_price: 'Изменить цену',
    change_price_title: 'Изменить цену продажи NFT',
    sell_success: 'Успешно размещено на продажу!',
    nft_minted: 'Промаркированные NFT',
    history_title: 'История',
    history_text: 'История транзакций',
    nft_transaction: 'Транзакция NFT',
    ste_transaction: 'Транзакция STE',
    stt: 'STT',
    time: 'Время',
    type_transaction: 'Тип транзакции',
    type_nft: 'Тип NFT',
    id_nft: 'ID NFT',
    price_nft: 'Цена',
    transfer_nft: 'Отправитель / Получатель',
    fee_nft: 'Комиссия',
    type_wallet: 'Тип кошелька',
    total: 'Сумма',
    hash: 'Хэш',
    wallet_to: 'Адрес получателя',
    status: 'Статус',
    copySuccess: 'Успешно скопировано',
    copyFail: 'Не удалось скопировать',
    not_available: 'NFT продано или недоступно!',
    transfer: "Перевести",
    collaborators_title: "Партнеры"
};
